var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScale0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "475.7px",
    height: "266.35px",
    viewBox: "0 0 475.7 266.35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    r: 819.2,
    cx: 0,
    cy: 0,
    spreadMethod: "pad",
    gradientTransform: "matrix(0.12982177734375 0 0 0.12982177734375 234.65 159.3)",
    id: "gradient0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    r: 819.2,
    cx: 0,
    cy: 0,
    spreadMethod: "pad",
    gradientTransform: "matrix(0.12982177734375 0 0 0.122650146484375 234.4 112.1)",
    id: "gradient1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    gradientUnits: "userSpaceOnUse",
    r: 819.2,
    cx: 0,
    cy: 0,
    spreadMethod: "pad",
    gradientTransform: "matrix(0.019775390625 0 0 0.019775390625 234.15 226.95)",
    id: "gradient2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "url(#gradient0)",
    d: "M234.3 212.5 L229.7 212.5 229.7 212.45 234.3 11.7 239.15 212.45 239.15 212.5 234.3 212.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666666",
    strokeWidth: 0.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M234.3 11.7 L234.3 0 M234.3 212.5 L234.3 257.1 M234.3 257.6 L234.3 257.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666666",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M234.3 257.1 L468.7 257.1 M234.3 257.1 L0 257.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#gradient1)",
    strokeWidth: 0.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M229.7 212.45 L234.3 11.7 239.15 212.45"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "#3399ff",
    fillOpacity: 0.2,
    d: "M261.4 200.85 Q272.65 212.1 272.65 228 272.65 243.9 261.4 255.1 250.2 266.35 234.3 266.35 218.4 266.35 207.15 255.1 195.95 243.9 195.95 228 195.95 212.1 207.15 200.85 218.4 189.65 234.3 189.65 250.2 189.65 261.4 200.85 M250.05 226.95 Q250.05 220.35 245.4 215.7 240.75 211.05 234.15 211.05 227.55 211.05 222.9 215.7 218.25 220.35 218.25 226.95 218.25 233.55 222.9 238.2 227.55 242.85 234.15 242.85 240.75 242.85 245.4 238.2 250.05 233.55 250.05 226.95"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fill: "url(#gradient2)",
    d: "M250.05 226.95 Q250.05 233.55 245.4 238.2 240.75 242.85 234.15 242.85 227.55 242.85 222.9 238.2 218.25 233.55 218.25 226.95 218.25 220.35 222.9 215.7 227.55 211.05 234.15 211.05 240.75 211.05 245.4 215.7 250.05 220.35 250.05 226.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#666666",
    strokeWidth: 0.05,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M261.4 200.85 Q272.65 212.1 272.65 228 272.65 243.9 261.4 255.1 250.2 266.35 234.3 266.35 218.4 266.35 207.15 255.1 195.95 243.9 195.95 228 195.95 212.1 207.15 200.85 218.4 189.65 234.3 189.65 250.2 189.65 261.4 200.85 M250.05 226.95 Q250.05 233.55 245.4 238.2 240.75 242.85 234.15 242.85 227.55 242.85 222.9 238.2 218.25 233.55 218.25 226.95 218.25 220.35 222.9 215.7 227.55 211.05 234.15 211.05 240.75 211.05 245.4 215.7 250.05 220.35 250.05 226.95"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale0);
export default __webpack_public_path__ + "static/media/scale_0.c69d2cf0745f9fdd5a609b633cfa8b2e.svg";
export { ForwardRef as ReactComponent };